'use client';
import type {FC} from 'react';
import clsx from 'clsx';
import {usePathname} from 'next/navigation';

import {Button} from '@/modules/foundation/components/button';
import {Link} from '@/modules/foundation/components/link';

export type NavLinkType = {
	type: 'navlink';
	title: string;
	href: string;
	targetBlank?: boolean;
	featured?: boolean;
};

type NavLinkProps = {
	link: NavLinkType;
	onClick?: () => void;
};

export const NavLink: FC<NavLinkProps> = ({link, onClick}) => {
	const pathname = usePathname();

	if (link.featured) {
		return (
			<Button asChild size="medium">
				<Link
					onClick={onClick}
					href={link.href}
					targetBlank={link.targetBlank}
					className={clsx('inline-block')}
				>
					{link.title}
				</Link>
			</Button>
		);
	}

	return (
		<Link
			onClick={onClick}
			href={link.href}
			targetBlank={link.targetBlank}
			pathname={pathname}
			className={clsx('inline-block', 'no-underline')}
		>
			{link.title}
		</Link>
	);
};
